import{b as e}from"./chunk-EMIEIAAH.js";function u(...r){return e(y,r)}function y(r,t,o){let n=0;for(let a of r)t(o,a)>0&&(n+=1);return n}export{u as a};
